import { MDSTheme, MDSTypography } from '@marqvision/mds/core';

export enum LanguageEnum {
  Korean = 'ko',
  English = 'en',
}

export const isEndWithConsonant = (korStr: string) => {
  const finalChrCode = korStr.charCodeAt(korStr.length - 1);
  // 0 = 받침 없음, 그 외 = 받침 있음
  const finalConsonantCode = (finalChrCode - 44032) % 28;
  return finalConsonantCode !== 0;
};

const enScript = {
  NeedWorldwideTrademarkFiling: 'Need Worldwide Trademark Filing?',
  ARevolutionaryWayToRegisterTrademarks: 'A revolutionary way to<br />register trademarks abroad',
  ApplyNow: 'Apply now',
  GetYourTrademarkNow: 'Get your trademark now',
  WhatAreTheChallengesOfFilingAbroad: 'What are the challenges of filing abroad?',
  WhenItComesToRegisteringYourTrademarksAbroad:
    'When it comes to registering your trademarks abroad, many rights owners often find themselves overwhelmed when navigating the complex process of filing for non-domestic trademarks.<br /><br />Finding a reliable local law firm in each country can be difficult, expensive, and time-consuming leaving rights owners wondering what their best option is.',
  ExperienceTheIndustry: "Experience the industry's best way to register trademarks wherever you need them",
  WeOnlyPartnerWithTopTierLawFirmsInEachCountry:
    'We only partner with top-tier law firms in each country, so you have access to the best local law firms around the world.<br/><br/>Using our simple online application, you can submit within minutes and check your filling status anytime on our easy-to-use dashboard — no need to call or send emails to check the progress of your application!',
  HowDoesItWork: 'How does it work?',
  SubmitYourApplication: 'Submit your application',
  SubmittingAnApplicationOnlyTakes:
    "Submitting an application only takes a few minutes and you'll get your initial quote right away.",
  LocalLawFirmAssessment: 'Local law firm assessment',
  OurPartnerLawFirmWillReview:
    'Our partner law firm will review your application and get back to you with in-depth analysis and recommendations',
  UploadDocuments: 'Upload documents',
  ThroughTheMyApplicationDashboard:
    'Through the “My application” dashboard, you can see a list of required documents to upload and check your application’s real-time status.',
  ExaminationByTheTrademarkOffice: 'Examination by the trademark office',
  OnAverageFilingToFinalApprovalTakes:
    'On average, filing to final approval takes 6 to 12 months depending on which country(s) you are registering for.',
  DoneExclamation: 'Done!',
  OnceEverythingIsCompletedAnd:
    'Once everything is completed and your trademark is approved, you will receive the Certificate of Registration and relevant documents.<br/><br/>Congrats! Your trademark is officially now yours!',
  SeeYourInitialQuoteBeforeYouFile: 'See your initial quote before you file',
  FreeNoObligationNoCommitment: 'Free  ·  No obligation  ·  No commitment',
  WhyMarqFolio: 'Why MARQ Folio?',
  AreYourTMsAtRiskInChina: "Are your TM's at risk in China?",
  WeOnlyPartnerWithTopTierLawFirms:
    'We only partner with top-tier law firms in each country. Through this leading partner network, brands are able to enjoy high-quality advice at a reasonable price.',
  WhatsInclude: 'What’s included in the price?',
  TrademarkEligibilityCheck: 'Trademark eligibility check',
  ConsultationWithLeadingLawFirms: 'Consultation with leading law firms',
  ApplicationPreparationAndFiling: 'Application preparation and filing',
  GovernmentFeesForApplication: 'Government fees for application',
  RealtimeApplicationProgressUpdate: 'Real-time application progress updates',
  GovernmentAndServiceFeesForRegistration: 'Government & service fees for registration',
  GovernmentAndServiceFeesInCaseOfPreliminaryRejections: 'Government & service fees in case of preliminary rejections',
  OurStory: 'Our Story',
  MarqVisionHelpsGlobalBrands:
    'MarqVision helps global brands identify and remove counterfeits from over 1,500 online marketplaces worldwide. Counterfeiting is a massive and growing threat across the world. MarqVision is on a mission to protect creativity and innovation with technology that allows brands to automatically monitor and protect their IPs. Harnessing image recognition and natural language processing, this AI-powered SaaS makes it faster than ever to take down counterfeits.<br /><br />MarqVision was founded in 2020 by Harvard Law graduates and is backed by DST Global Partners, Softbank, Atinum Investments, Bass Investment, and Y Combinator. The recipient of a prestigious 2022 Innovation Award from LVMH Moët Hennessy Louis Vuitton (LVMH), MarqVision is also part of the LVMH accelerator program, La Maison des Startups, at the Station F incubator. MarqVision is bringing forth the next evolution of brand protection for businesses everywhere.',
  LearnMore: 'Learn more: ',
  EnjoyMoreTransparency: 'Enjoy more transparency',
  OurDashboardProvidesYouWith:
    'Our dashboard provides you with one centralized location to check and manage the progress of all your applications in real-time.',
  GetYourTrademarkFaster: 'Get your trademarks faster',
  OurRevolutionaryOnlineProcess:
    'Our revolutionary online process optimizes communication, reducing your time and cost for filing.',
  WorkWithTheBestLocalLawFirms: 'Work with the best local law firms',
  OurEliteGlobalNetworkOfTopTierLawFirms:
    'Our elite global network of top-tier law firms specialize in local trademark laws so you can file with confidence.',
  SaveTimeWithASimpleOnlineProcess: 'Save time with a simple online process',
  SubmittingAnApplicationOnlyTakesAFewMinutes:
    'Submitting an application only takes a few minutes and our intuitive application module will walk you through every step.',

  GovernmentFee: 'Government fee',
  ServiceFee: 'Service fee',
  ProtectionPlan: 'Protection plan',

  AreYourTrademarksAtRiskInChina: 'Are your trademarks at risk in China?',
  DontLoseYourTrademarksToSquatters: "Don't lose your trademarks to squatters.",
  NineDotThreeMillion: '9.3M',
  TrademarksRegisteredInChinaIn2020: 'trademarks registered in China in 2020',
  ThreeMonths: '3 months',
  YouOnlyHaveThreeMonthsHTML:
    'You only have <b>3 months to file an opposition</b> after the publication of a squatted trademark',
  FiveYears: '5 years',
  YouMustFileAnInvalidationHTML:
    "You must file an <b>invalidation within 5 years</b> of the squatted trademark's registration",
  FifteenHundredThousand: '$150,000',
  TakingBackYourLostTrademark:
    'Taking back your lost trademark can cost an <b>average of $150,000 USD</b> and takes at least a year',
  TakeControlOfYourTrademarksInChina: 'Take control of your trademarks in China',
  AutomaticallyReceiveANotification:
    'Automatically receive a notification when your trademark has been submitted for registration by squatters in China.',
  SignUpNow: 'Sign up now',
  HasYourTrademarkAlreadyBeenRegisteredInChina: 'Has your trademark already been registered in China?',
  WeCanHelp: 'We can help! Our experienced partners specialized in recapturing squatted trademarks.',
  GetYourTrademarksBackNow: 'Get your trademarks back now',
  FileAnApplication: 'File an application',
  MyApplication: 'My application',
  IpManagement: 'IP management',
  Profile: 'Profile',
  Login: 'Sign in',
  Yes: 'Yes',
  No: 'No',
  YouMustCreateSeperateAccount:
    "Note that you'll need to create a separate MARQ Folio account,<br />even if you've already registered on MARQ Commerce or MARQ Content",
  IAlreadySignedUp: 'Already have a MARQ Folio account? Sign in',
  EmailAddress: 'Email',
  Password: 'Password',

  IncorrectPassword: 'Incorrect password. Please try again or reset your password.',
  ForgotPassword: 'Forgot your password?',
  LoginSuccessful: 'Successfully signed in!',
  VerifyEmailSending: 'Sending verification email',
  VerifyEmailSent: 'Verification email sent',
  VerifyEmail: 'Verify your email',
  EnterValidEmail: 'Please enter a valid email address',
  SendAgainAfterNSeconds: (timer: number) => `Resend after ${timer} seconds`,
  ResendVerifyEmail: 'Resend verification email',
  ToConfirmYour: 'To confirm your email address.',
  GoToYourEmail: '1. Please click on the link in the verification email',
  ReturnToThisScreen: '2. Return to this screen and complete verification',
  CompleteVerification: 'Complete verification',
  Checking: 'Checking',
  VerificationIncomplete: 'Verification incomplete. Please check inbox or email address.',
  Verified: 'Verified',
  MoreThan8Char: 'More than 8 characters',
  IncludeAtLeast1Letter: 'Include at least 1 letter, 1 special character and 1 number',
  PasswordConfirmation: 'Confirm password',
  Confirmed: 'Confirmed',
  ResetPasswordAndLoggingIn: 'Reset password and logging in',
  ResetPasswordAndLogin: 'Reset password and sign in',
  SigningUp: 'Signing up',
  SignUp: 'Create account',
  LoggingIn: 'Logging in',
  EmailDoesNotExist: 'This email account does not exist. Please try again or sign-up.',
  EmailAlreadyRegistered: 'This email is already registered. Please sign in.',
  ReferralCode: 'Referral Code (optional)',
  SignInToYourAccount: 'Sign in to your account',
  NewToMARQFolio: 'New to MARQ Folio?',
  CreateAnAccount: 'Create an account',
  Submit: 'Submit',
  Continue: 'Continue',
  NotVerified: 'Not yet verified',

  Search: 'Search',
  CantFindWhat: 'Can’t find what you’re looking for?',
  EnterTheCountry: "Enter the countries you're hoping to register. We'll get back to you shortly.",
  SelectType: 'Select the type of trademark you wish to register',
  Word: 'Word',
  EnterTheWord: 'Enter the word you wish to register',
  UploadYourLogo: 'Upload your logo trademark',
  UploadYourComposite: 'Upload your composite trademark',
  WordTrademarkTips: 'Word trademark tips',
  MakeUpYourOwn: 'Make up your own business name (like Microsoft)',
  AvoidGeneric: 'Avoid generic or self-descriptive names (like Delicious BBQ, Frozen Yogurt)',
  IfYouWishToFileInChina:
    'If you wish to file in China, try not to include a specific location name (like Boston Chowder)',
  LogoTrademarkTips: 'Logo trademark tips',
  ChooseALogoMark:
    'Choose a logo mark that isn’t confusingly similar to any existing (already filed or registered) marks',
  CompositeTrademarkTips: 'Composite trademark tips',
  ItIsRecommendToRegister:
    'It is recommended to register your word and logo trademark separately for complete protection. Even seemingly small changes to a design, such as a brand name moving to the side of a graphic instead of resting on top of it, could warrant filing a new trademark application.',
  EnterTheWordElement: 'Enter the word element in your mark',
  Logo: 'Logo',
  Composite: 'Composite',
  ProvidesTheBroadestLevelOfProtection:
    "Provides the broadest level of protection for your brand's name used in any form, regardless of style, design, font, or color",
  ProvidesProtectionForYourBrand:
    "Provides protection for your brand's identifying design and visual elements (without any text) including all color variations",
  ProvidesProtectionForBoth: 'Provides protection for both the visual elements and the stylized name of your brand',
  FileIsLarge: 'Maximum size is 20MB',
  BreadCosmeticsClass: 'Bread, Cosmetics, Class 1, Class 43',
  NSelected: (n: number) => `${n} Selected`,
  SelectAll: 'Select All',
  Clear: 'Clear',
  Optional: 'Optional',
  OR: 'OR',
  UploadFile: 'Upload File',
  OwnerType: 'Owner type',
  Individual: 'Individual',
  Company: 'Company',
  LegalNameOfIndividualOwner: 'Legal name of individual owner',
  LastName: 'Last name',
  FirstName: 'First name',
  Nationality: 'Nationality of owner',
  Country: 'Country',
  CompanyName: 'Legal name of company',
  CountryCorporated: 'Country corporated',
  PhoneNumber: 'Phone Number',
  CountryNumber: 'Country number',
  ApplicationDetails: 'Application details',
  ApplicantDetails: 'Applicant details',
  TrademarkType: 'Trademark type',
  ReferencesOfTrademarkUsages: 'References of trademark usages',
  UpdateMyInfo: 'Update my account information with this.',
  TotalPrice: 'Total',
  AddNMoreCountries: (n: number, p: number) => `Select ${n} countr${n > 1 ? 'ies' : 'y'} and save ${p}%`,
  NPercentsMultiCountryDiscount: (n: number) => `${n}% Multi-country discount`,
  NPercentsSecondAppDiscount: (n: number) => `${n}% Second submission discount`,
  NPercentsAdditionalDiscount: 'Additional discount',
  NClasses: (n: number) => (
    <>
      <span>{n}</span> Class{n == 1 ? '' : 'es'}
    </>
  ),
  FirstClass: 'First Class',
  NAdditionalClasses: (n: number) => `${n > 1 ? `${n} additional Classes` : `Additional Class`}`,
  GoodsAndServices: 'Goods and services',
  EditClass: 'Edit Class',
  Trademark: 'Trademark',
  WhoIsTheIntended: 'Who is the intended owner of the trademark?',
  Documents: 'Documents',

  SorryWeCannotProcess: 'Sorry, we cannot process your payment at the moment.',
  AreYouSureWantToDelete: 'Are you sure you want to delete this application?',
  ResumeApplication: 'Resume application',

  ContactDetails: 'Contact details',
  EnglishName: 'English name written on identification (e.g. passport, social security card)',
  EnglishNameBusiness:
    'English name written on business entity documentation (e.g. certificate of incorporation, tax registration certificate)',
  LegalNameOfCompany: 'Legal name of company',
  Address: 'Address',
  ChineseAddress: 'Chinese Address',
  WriteItMyself: 'Write it myself',
  RequestTranslation: 'Request translation',
  OurPartnerLawFirmWillTranslate:
    'Our partner law firm will translate your English address written above and use it in the application',
  IConsentUsingTranslated: 'I consent to using a translated address',
  EnglishAddress: 'English address written on identification (e.g. passport, social security card)',
  EnglishAddressBusiness:
    'English address written on business entity documentation (e.g. certificate of incorporation, tax registration certificate)',
  PaymentInProgress: 'Payment',
  AdditionalPaymentInProgress: 'Additional payment',
  AdditionalPayment: 'Additional payment',
  Recovery: 'Recovery',

  NeedHelpChoosingATrademarkType: 'Need help choosing a trademark type?',
  IfYouWishToFileMoreThan: 'If you wish to file more than one type, please submit multiple applications.',
  IfYouAreNotSureWhichTypeToChoose:
    'If you are not sure which type to choose, start with a word trademark as this offers the broadest level of protection.',
  Submitted: 'Your application has been submitted!',
  WhatAreTheNextSteps: 'What are the next steps?',
  YourPaymentIsConfirmedBy: 'Your payment is confirmed by Marq Vision.',
  YouSubmitInformationAnd: 'You submit information and documents requested by law firms.',
  LawFirmsReviewAll: 'Law firms review all documents and file the application to each country’s IP office.',
  IpOfficesExamineTheApplication:
    'IP offices examine the application. If there are additional documents requested by IP offices, law firms prepare them upon your approval.',
  IpOfficesAnnounceFinalResults:
    'IP offices announce final results. You receive the registration certificate if your application is approved.',
  FileAnotherApplication: 'File another application',
  CheckYourApplicationStatus: 'Check your application status',
  ThankYouPayment: 'Thank you!',
  ThankYouPaymentDesc1: (onClick?: () => void) => {
    return (
      <>
        You can continue working on your responses and documents&nbsp;
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onClick?.();
          }}
          style={{ textDecoration: 'none' }}
        >
          here
        </a>
        .
      </>
    );
  },
  ThankYouPaymentDesc2: 'Please provide required documents when you are ready.',
  ThankYouPaymentCompleted: "You're all set!",
  ThankYouPaymentCompletedDesc: 'Your submissions are in review',

  ThankYouPaymentDesc3: 'Your order has been placed successfully.',
  ThankYouPaymentDesc4: 'We will begin processing it right away.',
  PleaseCompleteYourPayment: 'Please complete the payment to continue',
  ThankYouForYourOrder: 'Thank you for your order!',
  DocumentsAndQuestionnaires: 'Documents & Questionnaire',
  DocumentsDescriptions1: 'Please provide the following materials when you are ready.',
  DocumentsDescriptions2: "We'll review your submissions and ready out to you in case we need anything else.",
  DocumentsProgressDone: (v: number, t: number) => `${v} / ${t} done`,
  DocumentsProgressAllSet: (v: number, t: number) => `${v} / ${t} done! You're all set.`,
  DocumentsRejectedDownloadLatest: 'Download your last submission',
  DocumentsUpload: 'Upload document',
  DocumentsSubmittedThisDoc: 'I’ve submitted this document',
  DocumentsEnterYourReplyHere: 'Enter your reply here',
  DocumentsSaving: 'saving...',
  DocumentsOther: 'Other',
  DocumentsPartneredWith: (partnerName: string) => `Partnered with ${partnerName}`,
  DocumentsNoPartnerInfo: 'Partner info not available',
  DocumentsStatusCompleted: 'Completed',
  DocumentsStatusReviewRequired: 'Review required',
  DocumentsSubmitRequiredQnaDocs: 'Submit required questionnaire & documents',
  DocumentsReviewYourDocs: 'Please review your documents',
  DocumentsNoDocumentsRequested: 'No documents requested',
  DocumentsHasBeenSigned: 'This document has been signed successfully!',
  FinishedWarningPopupTitle: 'Are you sure you want to leave?',
  FinishedWarningPopupDest: 'Your application can be filed once we receive your response and all required documents',
  FinishedWarningPopupStay: 'Stay',
  FinishedWarningPopupContinue: "I'll do it later",
  Leave: 'Leave',

  LoginSuccessAndAutoSaved: 'Sign in successful! Your application will be auto-saved.',
  DoYouWantToLeave: 'Do you want to leave the application? Your details will be lost.',
  // MyApplication: 'My application',
  ApplicationId: 'Application ID',
  ApplicationCount: (count: number) => (
    <>
      <MDSTypography variant="T14" weight="medium">
        {count}
      </MDSTypography>
      <MDSTypography variant="T14">applications</MDSTypography>
    </>
  ),
  NoApplications: 'No applications',
  SubmittedDateNewest: 'Submitted Date (Newest)',
  SubmittedDateOldest: 'Submitted Date (Oldest)',
  UpdatedDateNewest: 'Updated Date (Newest)',
  UpdatedDateOldest: 'Updated Date (Oldest)',
  LastSavedDate: 'Last saved date',
  SubmittedDate: 'Submission',
  DateFormat: 'MMM DD, YYYY',
  DateFormatSlash: 'MM/DD/YYYY',
  SeeDetail: 'See details',
  Apply: 'Apply',
  ContractAndPayment: 'Contract & Payment',
  PaymentRequested: 'Payment requested',
  PaymentSuccess: 'Payment success',
  PaymentFailed: 'Payment failed',
  PaymentCanceled: 'Payment canceled',
  PaymentOverdue: 'Payment overdue',
  PaymentIncomplete: 'Payment incomplete',
  Preparation: 'Preparation',
  File: 'File',
  Examination: 'Examination',
  FinalDecision: 'Final Decision',
  RegistrationGranted: 'Registration granted',
  RegistrationCompleted: 'Registration completed',
  Filed: 'Filed',
  OvercameMarks: 'Successfully overcame conflicting marks',
  FailedMarks: 'Failed to overcome conflicting marks',
  // Apply: 'Apply',
  FilingPending: 'Filing pending',
  StatusOfCountryUpdated: (countries: string, plural = false) =>
    `Status for ${Number(countries) ? `${countries} countries` : countries} ${plural ? 'have' : 'has'} been updated`,
  NewRequestFrom: (from: string, countries: string) =>
    `New request${from ? ` from ${from}` : ''}${countries ? ` about ${countries}` : ''}`,
  Enter: 'Enter',
  Request: 'Request',
  invoice: 'Invoice',
  DueDateClosest: 'Due date (closest)',
  ClassNumber: (number: string | number) => `Class ${number}`,
  TrademarkUsageHistory: 'Trademark usage history',
  AreYouSoldInUS: 'Are you currently using this trademark on any goods or services sold in the US?',
  WhenIsFirstInUs: 'When is the date of first commercial use in the US?',
  IDontKnow: 'I do not know',
  WhenIsDateOfFirst: 'When is the date of first use anywhere?',
  Send: 'Send',
  Other: 'Other',
  OtherDirect: 'Others (Direct input)',
  DateFormatWithTime: 'MMM DD, YYYY, HH:mm',
  YouCanAttachFile: (max: number) => `You can attach up to ${max} file${max > 1 ? 's' : ''} (max. 20MB each)`,

  ApplicationHasBeenUpdated: 'The application has been edited.',
  Change: 'Change',
  Save: 'Save',
  Cancel: 'Cancel',
  Logout: 'Log out',
  Payment: 'Payment',
  SavedCreditOrDebitCards: 'Saved credit or debit cards',
  AddNewCreditOrDebitCard: 'Add new credit or debit card',
  EndingInN: (n: string) => `ending in ${n}`,
  AddNewCard: 'Add new card',
  PleaseEnterAValidCardNumber: 'Please enter a valid card number',
  PleaseEnterAValidExpiryDate: 'Please enter a valid expiry date',
  PleaseEnterAValidCVVNumber: 'Please enter a valid CVV number',
  HowToFindYourCVVCVCHTML:
    '<b>How to find your CVV/CVC</b><br /><br />Visa, Mastercard, Discover, and UnionPay display the three-digit CVV number on the back of the card, to the right of the signature.<br /><br />American Express displays the four-digit CVV number on the front of the card.',
  Delete: 'Delete',
  WordTrademark: 'Word trademark',
  LogoTrademark: 'Logo trademark',
  CompositeTrademark: 'Composite trademark',
  Consent: (evntTerms: () => void, eventPP: () => void) => (
    <>
      I agree and consent to the{' '}
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          evntTerms();
        }}
        style={{ color: MDSTheme.palette.blue[700] }}
      >
        Terms & Conditions
      </a>{' '}
      and the{' '}
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          eventPP();
        }}
        style={{ color: MDSTheme.palette.blue[700] }}
      >
        Privacy Policy
      </a>
      .
    </>
  ),
  EmailVerified: 'Email verified',
  PleaseCloseThisScreen: 'Please close this screen and go to the MARQ Folio to complete the verification.',
  Add: 'Add',
  CompletePayment: 'Complete Payment',
  YourPaymentHasExpired: 'Your payment has expired. Please try again and make sure to complete payment by deadline.',
  CountriesAndClasses: 'Countries & Classes',
  OwnerAndInvoiceDetails: 'Owner & invoice details',
  BillingDetails: 'Billing Details',
  BillingDetailsMatch: 'Billing details match the owner’s details',
  StreetAddress: 'Street address',
  City: 'City',
  ZipPostalCode: 'Zip/Postal code',
  PaymentMethod: 'Payment Method',
  SelectYourPreferredPaymentMethod: 'Select your preferred payment method',
  CreditOrDebitCard: 'Credit or debit card',
  BankTransfer: 'Bank transfer',
  Cardholder: 'Cardholder',
  CardNumber: 'Card number',
  ExpirationDate: 'Expiration date',
  CVVCVC: 'CVV / CVC',
  SaveCardForLaterUse: 'Save card for later use',
  PayN: (n: string) => `Pay${n ? ` ${n}` : ''}`,
  ByClickingTheXButtonJSX: (x: string, onTermsClick: () => void, onPrivacyClick: () => void) => (
    <>
      <div>{`By clicking the “${x}” button, you agree with the `}</div>
      <div>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onTermsClick();
          }}
          style={{ color: MDSTheme.palette.bluegray[800] }}
        >
          {`Terms and Conditions `}
        </a>
        <span>and</span>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onPrivacyClick();
          }}
          style={{ color: MDSTheme.palette.bluegray[800] }}
        >
          {` processing of personal data.`}
        </a>
      </div>
    </>
  ),
  NewCreditOrDebitCard: 'New credit or debit card',
  Summary: 'Summary',
  AbovePriceIsValidUntil: (d: string) => `Pricing quote is valid until ${d}`,
  PlaceAnOrder: 'View account details',
  Order: 'Order',
  AccountHolder: 'Account holder',
  AccountNumber: 'Account number',
  RoutingNumber: 'Routing number',
  SwiftCode: 'SWIFT',
  BankName: 'Bank name',
  BankAddress: 'Bank address',
  Copy: 'Copy',
  CopiedToClipboard: 'Copied to clipboard',
  ReferenceNumber: 'Reference number',
  DueDate: 'Due date',
  YourTrademark: 'Your Trademark',
  TypeOfTrademark: 'Type of trademark',
  ShowDetails: 'Show details',
  HideDetails: 'Hide details',
  Countries: 'Countries',
  Classes: 'Classes',
  Class: 'Class',

  SendReport: 'Eligibility Report',
  Contract: 'Invoice',
  FilingSendReport: 'Filing Guide',
  FileDoneReport: 'Filed Application',
  OaReport: 'OA Report',
  OaCaNoti: 'Filed Response',
  OppReport: 'Notice of Publication',
  OppReqInfo: 'Opposition Report',
  OppReqDone: 'Filed Response',
  OppResultReport: 'Result',
  AppReport: 'Filed Application',
  AppLose: 'Result',
  AppWin: 'Result',
  RejectReport: 'Result & Next Steps',
  RegReport: 'Acceptance Notice',
  RegDoneReport: 'Invoice',
  RegElecReport: 'E-Certificate',
  CertSend: 'Certificate',
  CertAnnDone: 'Certificate & Registration Notice',
  RetrievalInfo: 'Application Draft',
  RetrievalDone: 'Filed Application',
  RetrievalReqReceive: 'Response',
  RetrievalReqDone: 'Response',
  RetrievalWin: 'Result',
  RetrievalLose: 'Result',

  ConfirmedPrice: 'Confirmed Price',
  Watch: 'Watch',
  WatchStartDate: 'Watch start date',
  WatchEndDate: 'Watch end date',
  GetStartedByAdding: 'Get started by adding your trademark to watch',
  BeAlertedWhenAThirdPartyTries:
    "Be alerted when a third party tries to file marks that are identical to or similar to your brand's mark",
  AddNewTrademarkToWatch: 'Add new trademark to watch',
  Table: 'Table',
  TmOverView: 'TM overview',
  NewTrademark: 'New trademark',
  WatchCount: (count: number) => (
    <>
      <span>{count}</span> Watch
    </>
  ),
  EnterTrademarkName: 'Enter trademark name',
  TrademarkName: 'Trademark name',
  TrademarkImage: 'Trademark image (logo)',
  CountryToWatch: 'Country to watch',
  SelectCountry: 'Select country(s)',
  SelectWatchStartDate: 'Select watch start date',
  SelectWatchEndDate: 'Select watch end date',
  ByCheckingTheBox:
    'By checking the box, I consent to applying for the trademark watch service and the collection of personal information for this purpose.',
  AddTrademarkToWatch: 'Add new trademark to watch',
  Status: 'Status',
  StatusDetails: 'Status details',
  YourRequestIsBeing: 'Your request is being reviewed. We will get back to you shortly.',
  EverythingLooksGreat: 'Everything looks great!',
  TakeAction: 'Take action',
  RemindMeLater: 'Remind me later',
  WatchStartDateDesc: 'Watch start date (Newest)',
  WatchStartDateAsc: 'Watch start date (Oldest)',
  UrgencyDesc: 'Status (Highest Urgency)',
  WatchCancel: 'Cancel',
  logo: 'Logo',
  word: 'Word',
  composite: 'Composite',
  designRight: 'Design right',
  ExpectedCompletion: 'Expected Completion',
  ExpectedCompletionDescription: 'This is an estimated registration date and may change as the case progresses',
  NoSearchResults: 'No search results found',
  TryChanging: 'Try changing the filter or search term',

  LogoMark: 'Logo mark',

  FilingApplication: 'Filing application',
  ApplicationInReview: 'Application in review',
  AwaitingTrademark: 'Awaiting trademark',
  TrademarkRegistered: 'Trademark registered',
  RequestInProgress: 'Request in progress',
  EvaluationInProgress: 'Evaluation in progress',
  WaitingForPayment: 'Waiting for payment',
  PreparingApplication: 'Preparing application',
  ApplicationDrafted: 'Application drafted',
  ApplicationDraftConfirmed: 'Application draft confirmed',
  ApplicationFiled: 'Application filed',
  PreliminarilyRefused: 'Preliminarily refused',
  DefendingRefusal: 'Defending refusal',
  PublishedForOpposition: 'Published for opposition',
  ApplicationOpposed: 'Application opposed',
  AppealingAgainstRejection: 'Appealing against rejection',
  RetrievingConflictingMarks: 'Retrieving conflicting marks',
  RetrievingTradeMarks: 'Retrieving trademarks',
  ConflictingMarksRetrieved: 'Conflicting marks retrieved',
  RetrievalFailed: 'Retrieval failed',
  WaitingForAdditionalPayment: 'Waiting for additional payment',
  AdditionalPaymentFailed: 'Additional payment failed',
  AdditionalPaymentCanceled: 'Additional payment canceled',
  ApplicationRejected: 'Application rejected',

  TrademarkApplication: 'Trademark application',
  ReadMore: 'Read more',
  ShowLess: 'Show less',
  ContinueToBillingDetails: 'Continue to billing details',
  SignAndContinue: 'Sign & Continue to payment',
  SaveAndContinue: 'Save & Continue',
  Edit: 'Edit',

  OrderForm: 'Order form',
  OrderFormDesc: 'Please read and sign this form',
  ConfirmFullName: 'Confirm your full name',
  ConfirmLegalName: 'Confirm your full legal name',
  OrderFormSign: (onClickTerms: () => void, onClickPP: () => void) => (
    <>
      By clicking Sign, I (1) agree that the above Full Name will be the electronic representation of my signature for
      all purposes when I (or my agent) use them on documents, including legally binding contracts - just the same as a
      pen-and-paper signature or initial, and (2) agree with the{' '}
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          onClickTerms();
        }}
      >
        Terms and Conditions
      </a>{' '}
      and{' '}
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          onClickPP();
        }}
      >
        processing of personal data
      </a>
      .
    </>
  ),
  DoYouWantToLeavePayment: 'Do you want to leave the page? Your details will be lost.',

  PleaseSignIn: 'Please sign in',
  ToContinueTo: (pageName: string) => `to continue to ${pageName}`,
  ThisPage: 'this page',

  OppInfo: 'Opposition information',
  OppReq: 'Opposition request',
  OppDone: 'Opposition done',
  OppResp: 'Opposition received',
  OppRedo: 'Opposition re-request',
  OppRedoDone: 'Opposition re-request completed',
  ResultReceive: 'Results received',

  // Request v2.13.0
  Title: 'Title',
  ResponseStatus: 'Response status',
  LastUpdatedDate: 'Last updated date',
  DoYouHaveAnyQuestion: 'Do you have any questions? Leave a message here.',
  EnterAnswer: 'Please enter your response or ask a question about the request.',
  Inquire: 'Inquire',
  DoYouHaveQuestion: 'Do you have a question?',
  Empty: 'No requests',
  NoRequests: 'No requests have been made yet',
  YourInquireSuccessfully: 'Your inquiry has been sent successfully!',
  YourResponseSuccessfully: 'Your response has been sent successfully!',
  PleaseSelectResponse: 'Please select a response or enter your message to send a reply.',
  PleaseEnterMessage: 'Please enter your message to send an inquiry',
  ReplyDue: 'Reply due',
  NFilesMaxFileSize: (fileSize: number) => `${fileSize === 1 ? '1 file' : `1-${fileSize} files`}. Max file size: 20MB`,
  Admin: 'Admin',
  RequestClosest: 'Request date (closest)',
  RequestOldest: 'Request date (oldest)',
  ClearSelection: 'Clear selection',
  NOtherCountries: (count: number) => `+ ${count} countr${count === 1 ? 'y' : 'ies'}`,

  accountNumber: 'Account number',
  bankName: 'Bank name',
  routingNumber: 'Routing number',
  swapNumber: 'Swap number',
  accountDetails: 'Account details',
  TransferLater: 'Transfer later',
  IHaveTransferred: 'I have transferred',
  Done: 'Done',
  TransferDueDate: 'Transfer due date',
  PleaseCompleteBank: 'Please complete the bank transfer.',
  ViewAccountDetails: 'View account details',
};

export type LocalizedStringsType = typeof enScript;

const koScript: LocalizedStringsType = {
  NeedWorldwideTrademarkFiling: '해외 상표 출원이 필요하신가요?',
  ARevolutionaryWayToRegisterTrademarks: '클릭 몇 번으로 전세계에<br />간편하게 출원해보세요',
  ApplyNow: '지금 신청하기',
  GetYourTrademarkNow: '지금 상표 출원하기',
  WhatAreTheChallengesOfFilingAbroad: '해외 상표 출원,<br />왜 어려울까요?',
  WhenItComesToRegisteringYourTrademarksAbroad:
    '길고 복잡한 해외 상표 출원 프로세스는 시작하기도 전부터 벅차게만 느껴집니다.<br/><br/>모든 국가에서 일일이 신뢰할만한 현지 로펌을 찾는 건 큰 시간이 소요되고, 한 번에 처리하려면 그만큼 수수료를 추가로 지불해야 하죠.<br/><br/>보다 효율적으로 전세계에 상표를 출원할 수는 없을까요?',
  ExperienceTheIndustry: '업계 최고 효율로 상표 출원을 도와드립니다',
  WeOnlyPartnerWithTopTierLawFirmsInEachCountry:
    '마크폴리오는 국가별 탑티어 로펌들과만 협업하며, 현지 최고의 서비스를 제공합니다.<br/><br/>간단한 온라인 신청서를 제출하고, 대시보드에서 손쉽게 출원 상태를 확인해보세요. 더이상 진행 상황 확인을 위해 매번 전화하거나 이메일을 보내지 않아도 됩니다.',
  HowDoesItWork: '어떻게 진행되나요?',
  SubmitYourApplication: '신청서 제출',
  SubmittingAnApplicationOnlyTakes: '단 몇 번의 클릭으로 간편하게 신청서를 제출하세요. 24시간 내 견적을 전달드립니다.',
  LocalLawFirmAssessment: '로펌 진단',
  OurPartnerLawFirmWillReview: '파트너 로펌에서 신청서를 리뷰한 후 출원 전략을 전달드릴 예정입니다.',
  UploadDocuments: '서류 전달',
  ThroughTheMyApplicationDashboard:
    '마크폴리오 대시보드에서 언제든 출원 현황을 확인하고, 필요한 서류를 로펌에 전달하실 수 있습니다.',
  ExaminationByTheTrademarkOffice: '특허청 검사',
  OnAverageFilingToFinalApprovalTakes:
    '특허청 심사를 거쳐 최종 등록이 결정됩니다. 일반적으로 6~12개월의 기간이 소요됩니다.',
  DoneExclamation: '완료!',
  OnceEverythingIsCompletedAnd: '등록이 완료되면 마크폴리오에서 등록증을 확인합니다. 상표 보호가 시작됩니다.',
  SeeYourInitialQuoteBeforeYouFile: '신청서 작성 전 최초 견적을 확인해 보세요',
  FreeNoObligationNoCommitment: '조건 · 계약 없이 무료로 견적 확인',
  WhyMarqFolio: '왜 마크폴리오에서<br/>출원해야 할까요?',
  AreYourTMsAtRiskInChina: '중국에 상표를<br />뺏기셨나요?',
  WeOnlyPartnerWithTopTierLawFirms:
    '마크폴리오는 국가별 최상위 로펌과 협업하며, 합리적인 가격으로 최고의 서비스를 제공합니다.',
  WhatsInclude: '가격에는 어떤 항목이<br/>포함되어 있나요?',
  TrademarkEligibilityCheck: '상표 적격성 검토',
  ConsultationWithLeadingLawFirms: '탑티어 로펌의 출원 전략 컨설팅',
  ApplicationPreparationAndFiling: '출원 서류 준비 및 제출',
  GovernmentFeesForApplication: '출원 관련 특허청 관납료',
  RealtimeApplicationProgressUpdate: '실시간 진행상황 업데이트',
  GovernmentAndServiceFeesForRegistration: '등록 관련 특허청 관납료 및 서비스 수수료',
  GovernmentAndServiceFeesInCaseOfPreliminaryRejections: '중간 사건 관련 특허청 관납료 및 서비스 수수료',
  OurStory: '마크비전 소개',
  MarqVisionHelpsGlobalBrands:
    '마크비전은 AI를 통해 모든 창작과 혁신을 보호하는 사명 아래 브랜드가 지식재산권(IP)을 생성, 관리, 보호 및 수익화할 수 있도록 지원합니다. 빠르게 커지는 글로벌 위조상품 시장에서 브랜드를 보호하기 위해 전세계 1,500개 이상의 마켓플레이스 및 소셜미디어에서 위조상품과 불법콘텐츠를 탐지하고 보호하고 있습니다. 대부분의 브랜드들이 반복적인 수동 작업을 통해 진행하던 IP 보호 업무를 이미지 인식 및 자연어 처리 기술 기반으로 자동화하여, 누구보다 빠르고 정확하게 위조상품과 불법콘텐츠를 제거하고 있습니다.<br /><br />마크비전은 2020년 하버드 로스쿨에서 탄생해 DST 글로벌, 소프트뱅크벤처스, 에이티넘인베스트먼트, 와이콤비네이터(YC) 등으로부터 투자를 유치했습니다. 루이비통모에헤네시(LVMH)가 주최하는 2022 LVMH 이노베이션 어워드에서 최종 우승을 차지하였습니다.',
  LearnMore: '더보기: ',
  EnjoyMoreTransparency: '투명한 가격 및 진행상황',
  OurDashboardProvidesYouWith:
    '하나의 대시보드에서 모든 출원서에 대한 진행상황을 실시간으로 확인하고 관리할 수 있습니다.',
  GetYourTrademarkFaster: '빠른 상표 등록',
  OurRevolutionaryOnlineProcess:
    '혁신적인 온라인 프로세스로 커뮤니케이션 시간과 비용을 최소화하여 더욱 빠르게 상표를 출원할 수 있습니다.',
  WorkWithTheBestLocalLawFirms: '국가별 탑티어 로펌 네트워크',
  OurEliteGlobalNetworkOfTopTierLawFirms:
    '현지 탑티어 로펌으로 구성된 마크폴리오를 통해 안전하게 상표를 출원할 수 있습니다.',
  SaveTimeWithASimpleOnlineProcess: '간편한 온라인 프로세스',
  SubmittingAnApplicationOnlyTakesAFewMinutes:
    '마크폴리오의 직관적인 대시보드를 통해 단 몇 분만에 신청서를 제출하고, 어려운 출원 프로세스를 쉽게 이해할 수 있습니다.',

  GovernmentFee: '관납료',
  ServiceFee: '서비스비',
  ProtectionPlan: '환불 보장 플랜',

  AreYourTrademarksAtRiskInChina: '중국에 상표를 뺏기셨나요?',
  DontLoseYourTrademarksToSquatters: '상표 선점은 누구한테든 일어날 수 있습니다',
  NineDotThreeMillion: '930만 개',
  TrademarksRegisteredInChinaIn2020: '2020년 기준, 중국에만 총 930만 개의 상표가 등록되었습니다',
  ThreeMonths: '3개월',
  YouOnlyHaveThreeMonthsHTML: '뺏긴 상표에 대한 이의제기는 <b>3개월 이내</b>에 이루어져야 합니다',
  FiveYears: '5년',
  YouMustFileAnInvalidationHTML: '뺏긴 상표에 대한 무효심판은 <b>5년 내</b>에만 청구할 수 있습니다',
  FifteenHundredThousand: '$150,000',
  TakingBackYourLostTrademark: '뺏긴 상표를 되찾는 데 <b>평균 $150,000</b>의 비용이 들며 최소 1년이 소요됩니다',
  TakeControlOfYourTrademarksInChina: '중국 상표, 놓치지 마세요',
  AutomaticallyReceiveANotification: '중국에서 상표 선점 위험을 자동으로 감지해 알림을 보내드립니다',
  SignUpNow: '상표 모니터링 신청하기',
  HasYourTrademarkAlreadyBeenRegisteredInChina: '이미 상표를 뺏기셨나요?',
  WeCanHelp: '상표 선점 관련 경험이 풍부한 마크폴리오의 파트너 로펌들이 도와드리겠습니다',
  GetYourTrademarksBackNow: '지금 상표 되찾기',
  FileAnApplication: '신청서 작성',
  MyApplication: '내 신청내역',
  IpManagement: '상표권 관리',
  Profile: '내 정보',
  Login: '로그인',
  Yes: '네',
  No: '아니오',
  YouMustCreateSeperateAccount: '마크커머스/마크콘텐츠 계정이 이미 있더라도, 마크폴리오에 새로 가입해주셔야 합니다',
  IAlreadySignedUp: '이미 계정이 있습니까? 로그인하기',
  EmailAddress: '이메일 주소',
  Password: '비밀번호',
  IncorrectPassword: '비밀번호가 일치하지 않습니다. 다시 시도해주세요.',
  ForgotPassword: '비밀번호를 잊으셨나요?',
  LoginSuccessful: '로그인에 성공했습니다!',
  VerifyEmailSending: '인증 메일 전송중',
  VerifyEmailSent: '인증 메일 발송됨.',
  VerifyEmail: '이메일 인증하기',
  EnterValidEmail: '유효한 이메일 주소를 입력해주세요',
  SendAgainAfterNSeconds: (timer) => `${timer}초 후 다시 시도.`,
  ResendVerifyEmail: '인증 메일 재발송',
  ToConfirmYour: '이메일로 발송된 URL에 접속한 후 인증 완료하기를 클릭해주세요',
  GoToYourEmail: '',
  ReturnToThisScreen: '',
  CompleteVerification: '인증 완료',
  Checking: '확인중',
  VerificationIncomplete: '인증이 완료되지 않았습니다. 받은메일함 혹은 이메일주소를 확인해주세요.',
  Verified: '인증되었습니다!',
  MoreThan8Char: '8자 이상',
  IncludeAtLeast1Letter: '영문, 특수문자, 숫자를 모두 1자 이상 포함해주세요',
  PasswordConfirmation: '비밀번호 확인',
  Confirmed: '확인되었습니다',
  ResetPasswordAndLoggingIn: '비밀번호 변경 및 로그인중',
  ResetPasswordAndLogin: '비밀번호 변경 및 로그인',
  SigningUp: '가입중',
  SignUp: '계정 생성하기',
  LoggingIn: '로그인중',
  EmailDoesNotExist: '존재하지 않는 이메일 계정입니다. 다시 시도해 보거나 가입해주세요.',
  EmailAlreadyRegistered: '이미 가입된 이메일 입니다. 로그인 해주세요.',
  ReferralCode: '추천 코드 (선택)',
  SignInToYourAccount: '로그인',
  NewToMARQFolio: '마크폴리오 계정이 없으신가요?',
  CreateAnAccount: '계정 생성하기',
  Submit: '제출',
  Continue: '계속',
  NotVerified: '아직 인증되지 않았습니다.',

  Search: '검색',
  CantFindWhat: '원하는 국가를 찾으실 수 없나요?',
  EnterTheCountry: '등록 희망하는 국가명을 입력해주세요. 빠르게 검토 후 안내 드리겠습니다.',
  SelectType: '어떤 유형의 상표를 출원하고 싶으신가요?',
  Word: '문자',
  EnterTheWord: '출원하려는 문자를 입력해주세요',
  UploadYourLogo: '도형 상표 이미지를 첨부해주세요',
  UploadYourComposite: '복합 상표 이미지를 첨부해 주세요',
  WordTrademarkTips: '문자 상표 팁',
  MakeUpYourOwn: '고유한 상호를 선택해보세요 (예: 마이크로소프트)',
  AvoidGeneric: '지나치게 포괄적이거나 단순 설명적인 명칭은 피해주세요 (예: 맛있는 BBQ, 얼린 요거트)',
  IfYouWishToFileInChina: '중국에 출원을 희망하실 경우 특정 지역명을 포함하지 말아주세요 (예: 보스턴 차우더)',
  LogoTrademarkTips: '도형 상표 팁',
  ChooseALogoMark: '이미 출원 혹은 등록된 상표와 비슷한 로고를 고르지 않도록 유의해주세요 ',
  CompositeTrademarkTips: '복합 상표 팁',
  ItIsRecommendToRegister:
    '완전한 보호를 원하실 경우 문자 상표와 도형 상표를 각각 따로 출원하는 것을 추천드립니다. 복합 상표로 등록한 뒤 상표 디자인이 바뀌게 되면 (예: 로고 위치가 브랜드명 위에서 옆으로 옮겨짐) 새로운 상표 출원이 필요해질 수 있습니다.',
  EnterTheWordElement: '상표의 문자 부분을 입력해주세요',
  Logo: '도형',
  Composite: '복합',
  ProvidesTheBroadestLevelOfProtection:
    '스타일, 디자인, 폰트, 색상과 관계 없이 가장 넓게 브랜드명을 보호 받을 수 있습니다',
  ProvidesProtectionForYourBrand:
    '브랜드를 나타내는 디자인 및 시각적 요소를 어떤 색상으로든 (텍스트 없이) 보호 받을 수 있습니다',
  ProvidesProtectionForBoth: '시각적 요소와 디자인된 브랜드 이름을 한 번에 보호 받을 수 있습니다',
  FileIsLarge: '파일 크기는 20MB를 넘지 않아야 합니다.',
  BreadCosmeticsClass: '빵, 화장품, 제1류, 제43류',
  NSelected: (n: number) => `${n} 선택됨`,
  SelectAll: '전체 선택',
  Clear: '전체 해제',
  Optional: '선택 항목',
  OR: '또는',
  UploadFile: '파일 첨부',
  OwnerType: '권리자 유형',
  Individual: '개인',
  Company: '법인',
  LegalNameOfIndividualOwner: '상표권자 이름',
  LastName: '성',
  FirstName: '이름',
  Nationality: '국적',
  Country: '국가',
  CompanyName: '법인명',
  CountryCorporated: '소속 국가',
  PhoneNumber: '연락처',
  CountryNumber: '국가 번호',
  ApplicationDetails: '신청서 상세',
  ApplicantDetails: '신청자 정보',
  TrademarkType: '상표 유형',
  ReferencesOfTrademarkUsages: '상표 사용 자료',
  UpdateMyInfo: '계정정보를 위 내용으로 업데이트합니다',
  TotalPrice: '총 견적',
  AddNMoreCountries: (n: number, p: number) => `국가 ${n}개 추가하고 ${p}% 할인 받으세요`,
  NPercentsMultiCountryDiscount: (n: number) => `${n}% 멀티 국가 할인`,
  NPercentsSecondAppDiscount: (n: number) => `두 번째 상표 할인 ${n}%`,
  NPercentsAdditionalDiscount: '추가 할인',
  NClasses: (n: number) => (
    <>
      <span>{n}</span>개 상품분류
    </>
  ),
  FirstClass: '첫 상품분류',
  NAdditionalClasses: (n: number) => `추가 상품분류 ${n}개`,
  GoodsAndServices: '상품 및 서비스',
  EditClass: '상품분류 수정', // TBC
  Trademark: '상표', // TBC
  WhoIsTheIntended: '상표권자는 누구인가요?',
  Documents: '서류',

  SorryWeCannotProcess: '죄송합니다. 지금은 결제를 진행하실 수 없습니다.',
  AreYouSureWantToDelete: '신청서를 삭제하시겠습니까?',
  ResumeApplication: '신청서 작성',

  ContactDetails: '개인 연락처 정보',
  EnglishName: '여권 및 주민등록증상 영문 성명',
  EnglishNameBusiness: '사업자등록증 및 법인등기부등록상 영문 사업장 소재지',
  LegalNameOfCompany: '법인명',
  Address: '주소',
  ChineseAddress: '한자 주소지 정보',
  WriteItMyself: '직접 기재',
  RequestTranslation: '번역 요청',
  OurPartnerLawFirmWillTranslate: '현지 로펌에서 상기 영문 주소를 번역하여 출원서에 기재하게 됩니다',
  IConsentUsingTranslated: '번역된 주소를 사용하는 데 동의합니다',
  EnglishAddress: '주민등록증상 주소의 영문 버전',
  EnglishAddressBusiness: '사업자등록증 및 법인등기부등록상 영문 사업장 소재지',
  PaymentInProgress: '결제',
  AdditionalPaymentInProgress: '추가 결제',
  AdditionalPayment: '추가 결제',
  Recovery: '선행상표대응',

  NeedHelpChoosingATrademarkType: '상표 유형 선택에 도움이 필요하신가요?',
  IfYouWishToFileMoreThan: '두 개 이상의 유형을 출원하고 싶으시다면 신청서를 나누어 제출해주세요.',
  IfYouAreNotSureWhichTypeToChoose:
    '어떤 유형을 선택해야 할지 모르겠다면, 가장 넓은 범위의 보호를 제공하는 문자 상표로 시작해보세요.',
  Submitted: '신청서가 제출되었습니다!',
  WhatAreTheNextSteps: '다음 절차는 어떻게 되나요?',
  YourPaymentIsConfirmedBy: '최종 견적에 대한 결제를 진행합니다.',
  YouSubmitInformationAnd: '각국 출원에 필요한 정보 및 서류를 취합합니다.',
  LawFirmsReviewAll: '로펌에서 출원서를 확정하여 각국 특허청에 제출합니다.',
  IpOfficesExamineTheApplication:
    '특허청에서 출원서를 심사합니다. 추가 요청 서류가 있을 경우 로펌에서 귀사와 확정해 서류를 보완합니다.',
  IpOfficesAnnounceFinalResults: '특허청에서 최종 결과를 발표합니다. 등록이 승인되면 상표 등록증을 받게 됩니다.',
  FileAnotherApplication: '추가 상표 신청',
  CheckYourApplicationStatus: '출원 현황 확인',
  ThankYouPayment: 'Thank you!',
  ThankYouPaymentDesc1: (onClick) => {
    return (
      <>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onClick?.();
          }}
        >
          여기
        </a>
        서 서류 제출을 마무리하실 수 있습니다.
      </>
    );
  },
  ThankYouPaymentDesc2: '가능한 빨리 서류를 제출해주세요.',
  ThankYouPaymentCompleted: '모두 제출되었습니다!',
  ThankYouPaymentCompletedDesc: '제출하신 서류를 검토하고 있습니다',
  ThankYouPaymentDesc3: 'Your order has been placed successfully.',
  ThankYouPaymentDesc4: 'We will begin processing it right away.',

  PleaseCompleteYourPayment: '사건 진행을 위해 결제를 진행해주세요',
  ThankYouForYourOrder: '주문이 완료되었습니다!',
  DocumentsAndQuestionnaires: '서류 및 질문',
  DocumentsDescriptions1: '아래 리스트의 서류들을 제출해주세요.',
  DocumentsDescriptions2: '검토 후 보완이 필요한 사항이 있으면 연락드리겠습니다.',
  DocumentsProgressDone: (v, t) => `${v} / ${t} 완료`,
  DocumentsProgressAllSet: (v, t) => `${v} / ${t} 완료! 모두 제출되었습니다.`,
  DocumentsRejectedDownloadLatest: '지난 제출 서류 다운로드',
  DocumentsUpload: '문서 업로드',
  DocumentsSubmittedThisDoc: '서류 제출을 완료했습니다',
  DocumentsEnterYourReplyHere: 'Enter your reply here',
  DocumentsSaving: '저장 중...',
  DocumentsOther: '기타',
  DocumentsPartneredWith: (partnerName) => `파트너 로펌: ${partnerName}`,
  DocumentsNoPartnerInfo: '파트너 로펌 정보가 없습니다.',
  DocumentsStatusCompleted: '제출 완료',
  DocumentsStatusReviewRequired: '검토 필요',
  DocumentsSubmitRequiredQnaDocs: '필요 서류를 제출해주세요',
  DocumentsReviewYourDocs: '서류를 검토해주세요',
  DocumentsNoDocumentsRequested: '제출해야 할 서류가 없습니다',
  DocumentsHasBeenSigned: 'This document has been signed successfully!',
  FinishedWarningPopupTitle: '나중에 다시 진행하시겠어요?',
  FinishedWarningPopupDest: '서류 제출이 완료된 국가부터 출원서가 작성됩니다.',
  FinishedWarningPopupStay: '취소',
  FinishedWarningPopupContinue: '나중에 하기',
  Leave: '나중에 하기',

  LoginSuccessAndAutoSaved: '로그인에 성공했습니다! 신청서를 자동저장합니다.',
  DoYouWantToLeave: '신청서 작성을 중단하시겠어요? 입력한 내용을 잃게 됩니다.',
  // MyApplication: '내 신청내역',
  ApplicationId: '신청서 ID',
  ApplicationCount: (count) => (
    <>
      <MDSTypography variant="T14">신청서</MDSTypography>
      <MDSTypography variant="T14" weight="medium">
        {count}
      </MDSTypography>
      <MDSTypography variant="T14">개</MDSTypography>
    </>
  ),
  NoApplications: '신청내역이 없습니다',
  SubmittedDateNewest: '제출일 (최신순)',
  SubmittedDateOldest: '제출일 (오래된순)',
  UpdatedDateNewest: '최종변경일 (최신순)',
  UpdatedDateOldest: '최종변경일 (오래된순)',
  LastSavedDate: '최종 저장일',
  SubmittedDate: '제출일',
  DateFormat: 'YYYY년 M월 D일',
  DateFormatSlash: 'MM/DD/YYYY',
  SeeDetail: '상세보기',
  Apply: '신청',
  ContractAndPayment: '견적 및 결제',
  PaymentRequested: '결제 요청',
  PaymentSuccess: '결제 완료',
  PaymentFailed: '결제 실패',
  PaymentCanceled: '결제 취소',
  PaymentIncomplete: '결제 진행중',
  PaymentOverdue: '결제 기한 만료',
  Preparation: '출원 준비',
  File: '출원',
  Examination: '심사',
  FinalDecision: '최종 결정',
  RegistrationGranted: '등록 결정됨',
  RegistrationCompleted: '등록 완료',
  Filed: '출원서 제출',
  OvercameMarks: '선행상표 대응 성공',
  FailedMarks: '선행상표 대응 실패',
  // Apply: '신청',
  FilingPending: '출원 보류',
  StatusOfCountryUpdated: (countries: string) => `${countries} 건의 상태가 변경되었습니다`,
  NewRequestFrom: (from: string, countries: string) =>
    `${countries ? `${countries} 관련 ` : ''}${from ? `${from}로부터 ` : ''}새로운 요청을 받았습니다`,
  Enter: '입력',
  Request: '요청',
  invoice: '인보이스',
  DueDateClosest: '마감기한 (가까운순)',
  ClassNumber: (number) => `제${number}류`,
  TrademarkUsageHistory: '상표 사용내역',
  AreYouSoldInUS: '해당 상표를 미국 상품 혹은 서비스에 사용하고 있나요?',
  WhenIsFirstInUs: '미국에서 처음 상업적으로 사용한 날이 언제인가요?',
  IDontKnow: '모름',
  WhenIsDateOfFirst: '국가와 관계없이 처음 상업적으로 사용한 날이 언제인가요?',
  Send: '전송',
  Other: '기타',
  OtherDirect: '기타 (직접 입력)',
  DateFormatWithTime: 'YYYY년 M월 D일 • hh:mm',
  YouCanAttachFile: (max: number) => `최대 ${max}개의 파일을 업로드해 주세요 (최대 파일당 20MB)`,
  ApplicationHasBeenUpdated: '신청서 내용이 수정되었습니다',
  Change: '변경',
  Save: '저장',
  Cancel: '이전',
  Logout: '로그아웃',
  Payment: '결제',
  SavedCreditOrDebitCards: '저장된 신용/체크카드',
  AddNewCreditOrDebitCard: '새로운 카드 추가',
  EndingInN: (n: string) => `**** ${n}`,
  AddNewCard: '새로운 카드 추가',
  PleaseEnterAValidCardNumber: '유효한 카드 번호를 입력해주세요',
  PleaseEnterAValidExpiryDate: '유효기간을 올바르게 입력해주세요',
  PleaseEnterAValidCVVNumber: '유효한 CVV를 입력해주세요',
  HowToFindYourCVVCVCHTML:
    'CVV/CVC 확인 방법<br/><br/>Visa, Mastercard, Discover, UnionPay는 카드 뒷면 서명 오른편에서 세 자리수 CVV/CVC를 확인하실 수 있습니다.<br/><br/>American Express는 카드 앞면에서 네 자리수 CVV를 확인하실 수 있습니다.',
  Delete: '삭제',
  WordTrademark: '문자 상표',
  LogoTrademark: '도형 상표',
  CompositeTrademark: '복합 상표',
  Consent: (evntTerms: () => void, eventPP: () => void) => (
    <>
      마크폴리오{' '}
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          evntTerms();
        }}
        style={{ color: MDSTheme.palette.blue[700] }}
      >
        이용약관
      </a>{' '}
      및{' '}
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          eventPP();
        }}
        style={{ color: MDSTheme.palette.blue[700] }}
      >
        개인정보 수집 및 이용
      </a>
      에 동의합니다.
    </>
  ),
  EmailVerified: '이메일 인증됨',
  PleaseCloseThisScreen: '이 화면을 닫고 MARQ Folio 화면으로 이동하여 인증을 완료해주세요.',
  Add: '추가',
  CompletePayment: '결제',
  YourPaymentHasExpired: '결제 기한이 만료되었습니다. 다시 시도 후 기한 내 결제를 완료해주세요.',
  CountriesAndClasses: '국가 및 상품분류',
  OwnerAndInvoiceDetails: '상표권자 및 결제 정보',
  BillingDetails: '결제 정보',
  BillingDetailsMatch: '결제 정보와 상표권자 정보가 동일합니다',
  StreetAddress: '도로명',
  City: '시/군/구',
  ZipPostalCode: '우편 번호',
  PaymentMethod: '결제 수단',
  SelectYourPreferredPaymentMethod: '결제 수단을 선택해주세요',
  CreditOrDebitCard: '신용/체크카드',
  BankTransfer: '계좌 입금',
  Cardholder: '이름 (법인명)',
  CardNumber: '카드 번호',
  ExpirationDate: '유효기간',
  CVVCVC: 'CVV / CVC',
  SaveCardForLaterUse: '다음 결제를 위해 카드 정보 저장',
  PayN: (n: string) => `${n ? `${n} ` : ''}결제`,
  ByClickingTheXButtonJSX: (x: string, onTermsClick, onPrivacyClick) => (
    <>
      <div>{`“${x}” 버튼을 클릭함으로써`}</div>
      <div>
        <a href="#" onClick={onTermsClick}>
          {`이용약관`}
        </a>
        <span>&nbsp;및&nbsp;</span>
        <a href="#" onClick={onPrivacyClick}>
          {`개인정보처리방침`}
        </a>
        <span>에 동의합니다</span>
      </div>
    </>
  ),
  NewCreditOrDebitCard: '새로운 카드 추가',
  Summary: '견적',
  AbovePriceIsValidUntil: (d: string) => `${d}까지 유효한 견적입니다`,
  PlaceAnOrder: '입금 정보 확인',
  Order: '주문',
  AccountHolder: '예금주명',
  AccountNumber: '계좌 번호',
  RoutingNumber: 'Routing number', // 영문 유지
  SwiftCode: 'SWIFT',
  BankName: '은행명',
  BankAddress: '주소',
  Copy: '복사',
  CopiedToClipboard: '클립보드에 복사되었습니다',
  ReferenceNumber: '입금 조회 번호',
  DueDate: '결제 마감일',
  YourTrademark: '상표',
  TypeOfTrademark: '상표 유형',
  ShowDetails: '상세 정보',
  HideDetails: '상세 정보 숨기기',
  Countries: '국가',
  Classes: '상품분류',
  Class: '상품분류',

  SendReport: '상표 조사 보고서',
  Contract: '인보이스',
  FilingSendReport: '출원예정보고서',
  FileDoneReport: '출원서',
  OaReport: 'OA 보고서',
  OaCaNoti: '답변서',
  OppReport: '출원공고 통지서',
  OppReqInfo: '이의신청 접수 및 대응전략보고서',
  OppReqDone: '이의신청 답변서',
  OppResultReport: '이의결정서',
  AppReport: '거절불복심판청구서',
  AppLose: '거절심결문',
  AppWin: '거절취소심결문',
  RejectReport: '거절결정통지 접수 및 대응안내보고서',
  RegReport: '등록결정서',
  RegDoneReport: '등록료납부확인서',
  RegElecReport: '전자등록증',
  CertSend: '등록증',
  CertAnnDone: '등록증 & 등록공고 통지서',
  RetrievalInfo: '이의/심판 청구예정보고서',
  RetrievalDone: '이의신청서/심판청구서',
  RetrievalReqReceive: '상대방 답변서',
  RetrievalReqDone: '재답변서',
  RetrievalWin: '이의/심판 승소심결문',
  RetrievalLose: '이의/심판 패소심결문',

  ConfirmedPrice: '확정 금액',

  Watch: '모니터링',
  WatchStartDate: '모니터링 시작일',
  WatchEndDate: '모니터링 종료일',
  GetStartedByAdding: '모니터링할 상표를 추가해보세요',
  BeAlertedWhenAThirdPartyTries:
    '제3자가 귀사의 상표와 유사하거나 동일한 상표를 출원하려고 할 시 알림을 받을 수 있습니다',
  AddNewTrademarkToWatch: '모니터링할 상표 추가',
  Table: '테이블뷰',
  TmOverView: '상표 요약뷰',
  NewTrademark: '상표 추가',
  WatchCount: (count: number) => (
    <>
      <span>{count}</span>개 모니터링중
    </>
  ),
  EnterTrademarkName: '상표명을 입력해주세요',
  TrademarkName: '상표명',
  TrademarkImage: '상표 이미지 (로고)',
  CountryToWatch: '모니터링할 국가',
  SelectCountry: '국가를 선택해주세요',
  SelectWatchStartDate: '시작일을 선택해주세요',
  SelectWatchEndDate: '종료일을 선택해주세요',
  ByCheckingTheBox: '체크 박스를 선택함으로써, 상표 모니터링 서비스 신청 및 그에 따른 개인정보 수집에 동의합니다',
  AddTrademarkToWatch: '모니터링 신청',
  Status: '상태 ',
  StatusDetails: '상세',
  YourRequestIsBeing: '신청서를 검토하고 있습니다. 곧 연락드리겠습니다.',
  EverythingLooksGreat: '발견된 위험이 없습니다',
  TakeAction: '위험 대응',
  RemindMeLater: '나중에 다시 알림 받기',
  WatchStartDateDesc: '모니터링 시작일 (최근순)',
  WatchStartDateAsc: '모니터링 시작일 (오래된순)',
  UrgencyDesc: '상태 (긴급한순)',
  WatchCancel: '취소',
  word: '문자 상표 ',
  logo: '로고 상표',
  composite: '복합 상표',
  designRight: '디자인권',
  ExpectedCompletion: '예상 등록일',
  ExpectedCompletionDescription: '예상 등록 일자이며, 사건 진행상황에 따라 변경될 수 있습니다',
  NoSearchResults: '검색 결과가 없습니다',
  TryChanging: '필터나 검색어를 변경해 보세요',

  LogoMark: '로고 마크',
  FilingApplication: '출원',
  ApplicationInReview: '심사',
  AwaitingTrademark: '대응',
  TrademarkRegistered: '등록',
  RequestInProgress: '신청서 작성',
  EvaluationInProgress: '신청서 검토',
  WaitingForPayment: '결제 대기',
  PreparingApplication: '출원서 준비',
  ApplicationDrafted: '출원서 초안 검토',
  ApplicationDraftConfirmed: '출원서 초안 검토 완료',
  ApplicationFiled: '출원서 특허청 제출',
  PreliminarilyRefused: '중간 거절됨',
  DefendingRefusal: '중간사건 대응',
  PublishedForOpposition: '특허청 공고',
  ApplicationOpposed: '이의신청 대응',
  AppealingAgainstRejection: '거절불복 대응',
  RetrievingConflictingMarks: '선행상표 대응',
  RetrievingTradeMarks: '선행상표 대응',
  ConflictingMarksRetrieved: '선행상표 대응 성공',
  RetrievalFailed: '선행상표 대응 실패',
  WaitingForAdditionalPayment: '추가 결제 대기',
  AdditionalPaymentFailed: '추가 결제 실패',
  AdditionalPaymentCanceled: '추가 결제 취소',
  ApplicationRejected: '최종 거절됨',
  TrademarkApplication: '내 상표 출원',
  ReadMore: '더 보기',
  ShowLess: '숨기기',
  ContinueToBillingDetails: '결제 정보 입력',
  SignAndContinue: '서명 및 다음',
  SaveAndContinue: '저장 및 다음',
  Edit: '수정',

  OrderForm: '주문서',
  OrderFormDesc: '주문서 내용을 확인하고 서명해주세요',
  ConfirmFullName: '성함을 입력해주세요',
  ConfirmLegalName: '성함을 입력해주세요',
  OrderFormSign: (onClickTerms, onClickPP) => (
    <>
      &quot;서명&quot; 버튼을 클릭함으로써, (1) 본인(또는 대리인)이 위 기입한 성함을 전자 서명에 활용하고, (2){' '}
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          onClickTerms();
        }}
      >
        이용약관
      </a>{' '}
      및{' '}
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          onClickPP();
        }}
      >
        개인정보처리방침
      </a>{' '}
      에 동의합니다. 본 전자 서명은 법적 구속력 있는 모든 형태의 계약에 있어 서면 서명 및 이니셜 기입과 동일한 효력을
      발휘합니다.
    </>
  ),
  DoYouWantToLeavePayment: '결제를 중단하시겠어요? 입력한 내용을 잃게 됩니다.',

  PleaseSignIn: '계속하려면 로그인하세요',
  ToContinueTo: (pageName) => `${pageName}${isEndWithConsonant(pageName) ? '을' : '를'} 계속하려면 로그인이 필요합니다`,
  ThisPage: '이 페이지',

  OppInfo: '이의/심판 안내',
  OppReq: '이의/심판청구 지시',
  OppDone: '이의/심판청구 완료',
  OppResp: '이의/심판청구 답변접수',
  OppRedo: '이의/심판청구 재답변지시',
  OppRedoDone: '이의/심판청구 재답변완료',
  ResultReceive: '결정/심결보고 접수',

  // Request v2.13.0
  Title: '제목',
  ResponseStatus: '응답 상태',
  LastUpdatedDate: '최종 수정일',
  DoYouHaveAnyQuestion: '문의사항이 있으신가요? 메시지를 남겨주시면 확인 후 답변드리겠습니다.',
  EnterAnswer: '답변 또는 질문사항을 남겨주세요',
  Inquire: '문의하기',
  DoYouHaveQuestion: '질문이 있으신가요?',
  Empty: '비어있음',
  NoRequests: '아직 요청사항이 없습니다',
  YourInquireSuccessfully: '문의가 성공적으로 전송되었습니다!',
  YourResponseSuccessfully: '답변이 성공적으로 전송되었습니다!',
  PleaseSelectResponse: '답변을 선택하거나 문의 내용을 입력해주세요',
  PleaseEnterMessage: 'Please enter your message to send an inquiry',
  ReplyDue: '응답 마감일',
  NFilesMaxFileSize: (fileSize) => `${fileSize === 1 ? '1개' : `1-${fileSize}개`} 첨부 가능. 파일당 최대 사이즈 20MB`,
  Admin: '마크폴리오팀',
  RequestClosest: '요청일 (최근순)',
  RequestOldest: '요청일 (오래된순)',
  ClearSelection: '초기화',
  NOtherCountries: (count) => `외 ${count}개 국가`,

  accountNumber: '계좌 번호',
  bankName: '은행명',
  routingNumber: 'Routing number',
  swapNumber: 'Swap number',
  accountDetails: '입금 정보',
  TransferLater: '나중에 하기',
  IHaveTransferred: '입금 완료',
  Done: '확인',
  TransferDueDate: '계좌 입금 기한',
  PleaseCompleteBank: '계좌이체를 완료해주세요.',
  ViewAccountDetails: '입금 정보 확인',
};

const LocalizedStrings: Record<LanguageEnum, LocalizedStringsType> = {
  [LanguageEnum.English]: enScript,
  [LanguageEnum.Korean]: koScript,
};

export default LocalizedStrings;
